// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__3sYcZ","white":"Spinner_white__2MNSh","cyan":"Spinner_cyan__34zd4","black":"Spinner_black__25Fna"};